export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");
    

        function closePopup() {
            $(".popup").removeClass("active show-content");
            mainWrap.removeClass("popup-open");
            $(".popups").removeClass("active");
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $target = $this.attr("href");

            $($target).addClass("active show-content").fadeIn(300);
            $($target).parent().addClass("active");
            mainWrap.addClass("popup-open");


        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });


        $(document).on("click", ".popups", function (event) {
            if (!$(event.target).closest(".popup-holder").length) {
                closePopup.call(this);
            }
        });
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js